module.exports = __webpack_public_path__ + "img/Group 1058five.8ee5ee56.png";